import { Identifiable, Project, ProjectExternalLink } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function extractList(data: { [key: string]: string }): ProjectExternalLink[] {
  return Object.entries<ProjectExternalLink>(
    JSON.parse(data.externalLinks || "{}"),
  ).map(([index, link]) => ({ ...link, index: parseInt(index) }));
}

function removeLink(link: ProjectExternalLink, list: ProjectExternalLink[]) {
  return JSON.stringify(
    list
      .filter(({ index }) => index !== link.index)
      .reduce((nextList, l) => ({ ...nextList, [l.index]: l }), {}),
  );
}

function removeProjectExternalLink(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Project>, link: ProjectExternalLink) =>
    httpClient
      .sendHttpRequest<Identifiable<Project>>({
        endpoint: `/projects/${uuid}`,
        method: HttpMethods.GET,
      })
      .then((project) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/projects/${project.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            data: {
              externalLinks: removeLink(link, extractList(project.data)),
            },
          },
        }),
      );
}

export { removeProjectExternalLink };
